import React from "react";
import { Navigate } from "react-router-dom";
import { Outlet } from "react-router";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "app/routes/hooks/useAuth";
import { constructReturnUrl } from "app/services/auth/jwt";

const Auth = ({ fallbackPath }) => {
  const { authUser } = useAuth();

  if (authUser?.isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={authUser?.isLoading ?? true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  } else {
    if (authUser?.data === null || authUser?.data === undefined) {
      return <Navigate to={constructReturnUrl(fallbackPath)} />;
    } else {
      return <Outlet />;
    }
  }
};

export default Auth;
